import { useToggle } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { AddPolicyModal } from 'modules/attendance/components/TimeTrackingSettings/AddPolicyModal'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import { useTimeTrackingFeatureAvailabilityForCurrentCompany } from 'modules/attendance/lib/useTimeTrackingFeatureAvailability'
import attendancePolicies from 'modules/attendance/store/collections/policies'
import attendanceSettings from 'modules/attendance/store/collections/settings'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import OvernightShifts from './Content/OvernightShifts'
import Projects from './Content/Projects'
import TimeTrackingPolicy from './Content/TimeTrackingPolicy'

const TimeTrackingSettings = () => {
  const [isAddModalOpen, toggleAddModal] = useToggle(false)
  const [isUpgradeModalOpen, toggleUpgradeModal] = useToggle(false)
  const hasOvertimeRequests = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_overtime_requests'
  )
  const hasTimeTrackingMultiPolicies = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_multi_policies'
  )
  const hasEditTimesheetAuthorization = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_edit_timesheet_authorization'
  )
  const { featureAvailability: projectsFeature } = useAttendanceFeatures(
    Features.projects_management
  )

  const addPolicy = hasTimeTrackingMultiPolicies ? toggleAddModal(true) : toggleUpgradeModal(true)

  useEffect(() => {
    track(trackingEvents.timeTracking.navigateToTimeTrackingSettingsPage)
  }, [])

  const { loading } = useAsyncData(
    () => Promise.all([attendancePolicies.fetch(), attendanceSettings.fetch()]),
    []
  )

  return (
    <ResponsivePage.Body showHeader={false} variant="full" loading={loading} error={null}>
      <TimeTrackingPolicy addPolicy={addPolicy} />
      {(hasOvertimeRequests || hasEditTimesheetAuthorization) && (
        <ApprovalsBlock
          category="time_tracking"
          title={i18n.t('time_tracking.settings.approvals.title')}
          description={i18n.t('time_tracking.settings.approvals.description')}
        />
      )}
      {projectsFeature && <Projects />}
      <OvernightShifts />
      {isAddModalOpen && <AddPolicyModal toggleAddModal={toggleAddModal} />}
      {isUpgradeModalOpen && (
        <UpsellingKit.FeatureModal
          moduleRequested={AvailableModules.time_tracking}
          featureRequested={Features.time_tracking_multi_policies}
          requestSource="attendance-settings"
          requestReason={ValidReasons.MissingFeature}
          isOpen={isUpgradeModalOpen}
          onClose={toggleUpgradeModal(false)}
          openFromUpsellButton={false}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default observer(TimeTrackingSettings)
